import {observer} from "mobx-react";
import {ScaCustomerItem} from "../../../store";
import {FieldAutoComplete, FormSection} from "../../ui";
import {FieldInput, FieldMultiSelect} from "@kroschke/react-ui";
import {DataElementTypeDto} from "../../../api/sca";
import {convertDocumentType} from "../../../api";
import {ScaFormProps} from "./commons";

const documentDropDownOptions = [
    DataElementTypeDto.COR_I,
    DataElementTypeDto.COR_II
].map(t => ({
    value: t,
    label: convertDocumentType(t)
}))

const ScaMainForm = observer(function ScaMainForm({
                                                      disabled,
                                                      validation,
                                                      customers,
                                                      value,
                                                      onChange,
                                                      onBlur,
                                                      onSearchCustomer
                                                  }: ScaFormProps) {
    return <>
        <div style={{overflow: 'visible', padding: '1em'}}>
            <FormSection
                label={"Allgemein"}
                children={
                    <>
                        <div className={"columns"}>
                            <div className={"column is-one-quarter"}>
                                <FieldAutoComplete
                                    label={"Kunde"}
                                    disabled={disabled}
                                    required={true}
                                    help={validation.customer}
                                    invalid={Boolean(validation.customer)}
                                    value={value.customer}
                                    options={customers}
                                    itemRenderer={c => c.label}
                                    search={onSearchCustomer}
                                    onBlur={() => !disabled && onBlur()}
                                    onChange={(customer: ScaCustomerItem | undefined) => {
                                        onChange({
                                            ...value,
                                            customer: customer!!
                                        })
                                        onBlur()
                                    }}
                                />
                            </div>
                            <div className={"column is-one-quarter"}>
                                <FieldInput
                                    disabled={disabled}
                                    required={true}
                                    maxLength={17}
                                    help={validation.vin}
                                    invalid={Boolean(validation.vin)}
                                    value={value.vin}
                                    onBlur={() => !disabled && onBlur()}
                                    onChange={fin => onChange({
                                        ...value,
                                        vin: fin
                                    })}
                                    inputTransform={(v: string) => {
                                        return v.toUpperCase()
                                    }}
                                    label={"Fahrgestellnummer"}
                                />
                            </div>
                            <div className={"column is-one-quarter"}>
                                <FieldInput
                                    disabled={disabled}
                                    required={true}
                                    maxLength={50}
                                    help={validation.externalReference}
                                    invalid={Boolean(validation.externalReference)}
                                    value={value.externalReference}
                                    onBlur={() => !disabled && onBlur()}
                                    onChange={externalReference => onChange({
                                        ...value,
                                        externalReference
                                    })}
                                    label={"ext. Referenz"}
                                />
                            </div>
                            <div className={"column is-one-quarter"}>
                                <FieldMultiSelect
                                    label={"Dokumente"}
                                    options={documentDropDownOptions}
                                    disabled={disabled}
                                    required={true}
                                    value={value.documents.map(doc => doc.type)}
                                    help={validation.documents}
                                    invalid={Boolean(validation.documents)}
                                    onBlur={() => onBlur()}
                                    onChange={selections => {

                                        const validSelection = selections.map(value => value as DataElementTypeDto)

                                        if (value.documents.length > selections.length) {
                                            onChange({
                                                ...value,
                                                documents: value.documents.filter(doc => validSelection.includes(doc.type))
                                            })
                                        } else {
                                            const missingTypes = validSelection.filter(
                                                type => !(value.documents.map(doc => doc.type.valueOf()).includes(type))
                                            )

                                            const updatedList = [
                                                ...value.documents,
                                                ...missingTypes.map(type => ({type}))
                                            ]

                                            onChange({
                                                ...value,
                                                documents: updatedList
                                            })
                                        }
                                    }}
                                />
                            </div>
                        </div>
                    </>
                }
            />
        </div>
    </>
})

export {
    ScaMainForm
}
